export const videos = [
    {
        title: "44th Uduma Padinharkara Thirumulkazcha 2017 - Part 01", 
        ylink: "https://www.youtube.com/embed/kD0LtKbv52E"
    }, 
    { 
        title: "44th Uduma Padinharkara Thirumulkazcha 2017 - Part 02", 
        ylink: "https://www.youtube.com/embed/ONKQES5U_lo"
    }, 
    { 
        title: "44th Uduma Padinharkara Thirumulkazcha 2017 - Part 03", 
        ylink: "https://www.youtube.com/embed/FAzhQ_67NAw"
    },
    { 
        title: "44th Uduma Padinharkara Thirumulkazcha 2017 - Part 04", 
        ylink: "https://www.youtube.com/embed/QAFltkXmEbE"
    },
    { 
        title: "43rd Uduma Padinharkara Thirumulkazcha 2016 - Part 01", 
        ylink: "https://www.youtube.com/embed/50PCCPSqCvI"
    }, 
    { 
        title: "43rd Uduma Padinharkara Thirumulkazcha 2016 - Part 02", 
        ylink: "https://www.youtube.com/embed/p97_ozZhR5Y"
    }, 
    { 
        title: "43rd Uduma Padinharkara Thirumulkazcha 2016 - Part 03", 
        ylink: "https://www.youtube.com/embed/HxlGeRPdeQ4"
    },
    { 
        title: "43rd Uduma Padinharkara Thirumulkazcha 2016 - Part 04", 
        ylink: "https://www.youtube.com/embed/wi0lrcqxf50"
    }, 
    { 
        title: "43rd Uduma Padinharkara Thirumulkazcha 2016 - Part 05", 
        ylink: "https://www.youtube.com/embed/ST9F2c4lWUQ"
    },
    { 
        title: "Palakunnu Sree Bhagavathi Kshethra Bharani Mahotsavam 2016 - Part 01", 
        ylink: "https://www.youtube.com/embed/h_mrVdg1PYo"
    }, 
    { 
        title: "Palakunnu Sree Bhagavathi Kshethra Bharani Mahotsavam 2016 - Part 02", 
        ylink: "https://www.youtube.com/embed/NAV3fMwt3EA"},

    { 
        title: "Palakunnu Sree Bhagavathi Kshethra Bharani Mahotsavam 2016 - Part 03", 
        ylink: "https://www.youtube.com/embed/LCvChCvzJhQ"
    }, 
    { 
        title: "Palakunnu Sree Bhagavathi Kshethra Bharani Mahotsavam 2016 - Part 04", 
        ylink: "https://www.youtube.com/embed/UkGutOFasbQ"
    }
];